import { render, staticRenderFns } from "./ScreeningReportQuestion.vue?vue&type=template&id=330f9008"
import script from "./ScreeningReportQuestion.vue?vue&type=script&lang=js"
export * from "./ScreeningReportQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports